import { actionTypes } from "../../Utils/Constants";
import { decrypt } from "../../Utils/Crypto";

const initialState = {
  loading: false,
  showLogin: false,
  token: decrypt(localStorage.getItem("tok")),
  username: decrypt(localStorage.getItem("un")),
  user: JSON.parse(decrypt(localStorage.getItem("_us"))),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_LOGIN:
      return { ...state, showLogin: true };
    case actionTypes.HIDE_LOGIN:
      return { ...state, showLogin: false };

    case actionTypes.INIT_LOGIN:
      return { ...state, loading: true };

    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        token: action.token,
        username: action.username,
        user: action.user,
        loading: false,
        showLogin: false,
      };

    case actionTypes.LOGIN_FAILED:
      return {
        ...state,
        loading: false,
      };

    case actionTypes.LOGOUT_SUCCESS:
      return { ...state, token: null, username: null, user: null };
    default:
      return { ...state };
  }
};
